import QmAppealPage from './qm-appeal.page';
export default QmAppealPage;
